import { IDatabaseItem } from "../interfaces";

export const TOYS_ITEMS: Array<IDatabaseItem> = [
	{
		title: "Babu - Kuchyňské náčiní",
		images: [{
			src: "01.webp",
			large: "01-large.webp",
		}, {
			src: "02.webp",
			large: "02-large.webp",
		}],
	},
	{
		title: "QiAike - Led board",
		desc: "Kaufland",
		images: [{
			src: "03.webp",
			large: "03-large.webp",
		}, {
			src: "04.webp",
			large: "04-large.webp",
		}],
	},
	{
		title: "Technic 42023 3 možnosti",
		desc: "Kaufland",
		images: [{
			src: "05.webp",
			large: "05-large.webp",
		}, {
			src: "06.webp",
			large: "06-large.webp",
		}],
	},
];
